import axios from './client'
import {
  ArtistFilters,
  ArtistsResponse,
  ArtistsStatsResponse,
  ArtistResponse
} from '../types/artist'

function buildArtistParams(filters: Omit<ArtistFilters, 'release_ids'>): URLSearchParams {
  const params = new URLSearchParams()
  Object.entries(filters).forEach(([key, value]) => {
    if (value == null) return
    if (Array.isArray(value)) {
      value.forEach(item => params.append(key, String(item)))
    } else {
      params.set(key, String(value))
    }
  })
  return params
}

export async function getArtists(filters: ArtistFilters = {}): Promise<ArtistsResponse> {
  const { release_ids, ...queryFilters } = filters
  if (release_ids && release_ids.length > 0) {
    const { data } = await axios.post('/artists/search', { release_ids, ...queryFilters })
    return data
  }
  const { data } = await axios.get('/artists', { params: buildArtistParams(queryFilters) })
  return data
}

export async function getArtist(id: number): Promise<ArtistResponse> {
  const { data } = await axios.get(`/artists/${id}`)
  return data
}

export async function getArtistsStats(): Promise<ArtistsStatsResponse> {
  const { data } = await axios.get('/artists/stats')
  return data
}

export interface ArtistSuggestion {
  id: number
  name: string
  matched_alias: string | null
}

export async function getArtistSuggestions(q: string): Promise<ArtistSuggestion[]> {
  const { data } = await axios.get('/artists/suggest', { params: { q } })
  return data.suggestions || []
}

export interface SimilarArtist {
  id: number
  name: string
  release_count: number
  avg_rating: number | null
  bayesian_elevated_score: number | null
  cover_image: string | null
  similarity_score: number
}

export async function getSimilarArtists(
  releaseId: number,
  limit = 10
): Promise<{ success: boolean; artists: SimilarArtist[] }> {
  const { data } = await axios.get(`/artists/similar-to-release/${releaseId}`, { params: { limit } })
  return data
}
